import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@homeleite/arch';
import { HomeComponent } from './home.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { title: 'Home Leite - Início' },
  },
];

export const HomeRoutes = RouterModule.forChild(routes);
